import login from '@/components/login/login'
import register from '@/components/register/register'
import navbar from '@/layout/navbar/navbar'
import banner from '@/layout/bannerUser/index'
import SDAUfooter from '@/layout/footer/footer'
import Pagination from '@/components/Pagination'
import Examination from '@/components/Examination/Examination'
import admissionExamination from '@/components/Examination/admissionExamination'



export default {
  install(Vue, options) {
    Vue.component('login', login)
    Vue.component('register', register)
    Vue.component('navbar', navbar)
    Vue.component('SDAUfooter', SDAUfooter)
    Vue.component('banner', banner)
    Vue.component('Pagination', Pagination)
    Vue.component('Examination', Examination)
    Vue.component('admissionExamination', admissionExamination)

  }
}